import Api from "@/services/Api";

export default {
  view(partyId) {
    return Api().get("parties/" + partyId);
  },
  store(form) {
    return Api().post("parties", form);
  },
  destroy(partyId) {
    return Api().delete("parties/" + partyId);
  },
  raiseReputation(partyId) {
    return Api().get("parties/" + partyId + "/raise_reputation");
  },
  lowerReputation(partyId) {
    return Api().get("parties/" + partyId + "/lower_reputation");
  },
  availableAncestors(partyId) {
    return Api().get("/parties/" + partyId + "/available_ancestors");
  },
  attachScenario(partyId, form) {
    return Api().put("parties/" + partyId + "/attach_scenario", form);
  },
  detachScenario(partyId, form) {
    return Api().put("parties/" + partyId + "/detach_scenario", form);
  },
  updateNotes(partyId, form) {
    return Api().put("parties/" + partyId + "/update_notes", form);
  }
};